var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Style"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.1249 13.05V19.75L1.5249 18.6625L4.1249 13.05ZM8.9749 21.85H6.1749V14.175L8.9749 21.85ZM11.3124 22.325L5.6124 6.70001L16.6124 2.70001L22.3124 18.325L11.3124 22.325ZM11.0135 10C11.2794 10 11.502 9.91006 11.6812 9.73016C11.8603 9.55026 11.9499 9.32735 11.9499 9.06141C11.9499 8.79548 11.86 8.57293 11.6801 8.39376C11.5002 8.2146 11.2772 8.12501 11.0113 8.12501C10.7454 8.12501 10.5228 8.21496 10.3437 8.39486C10.1645 8.57476 10.0749 8.79768 10.0749 9.06361C10.0749 9.32955 10.1649 9.5521 10.3448 9.73126C10.5247 9.91043 10.7476 10 11.0135 10ZM12.4249 19.9L19.8749 17.2L15.4999 5.12501L8.0499 7.82501L12.4249 19.9Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStyle);
export default __webpack_public_path__ + "static/media/icon-style.22961605e478d9c68aec9909428b9833.svg";
export { ForwardRef as ReactComponent };